import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { InstructorFacade } from '@app/store/instructor';
import { AssignmentsFacade } from '@app/store/assignments';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly instructorFacade = inject(InstructorFacade);
    private readonly assignmentsFacade = inject(AssignmentsFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly instructorId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    readonly hasAssignments = computed(() => this.assignmentsFacade.assignments(this.instructorId(), 'instructor')().length > 0);

    constructor() {
        effect(() => {
            this.assignmentsFacade.getAssignments(this.instructorId(), 'instructor');
        });
    }

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('instructors.delete.header'),
            message: this.translateService.instant('instructors.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('instructors.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('instructors.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.instructorFacade.deleteInstructor(this.instructorId());
            },
        });
    }
}
